
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';

const TextHoverLinkDiv = styled.div`
  color: blue;
  max-width: 90%;
  margin-top: 4px;
  &:hover {
    text-decoration: underline;
  }
`;

const TextHoverLink = styled.span`
  color: blue !important;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family:inherit;
  max-width: 100%;
    &:hover {
    /* Define hover styles here */
    text-decoration: underline;
  }
`;

const CollapsibleText = ({ channel = '', text = '', background = 'white', link, maxChars = 180 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    setIsTruncated(text.length > maxChars);
  }, [text, maxChars]);

  const toggleExpanded = () => setIsExpanded(prev => !prev);

  const newWindowFunc = () => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  return (
    <div style={{ fontFamily: 'inherit', fontWeight: 300, maxWidth: 400 }}>
      <span style={{ wordBreak: 'break-word' }}>
        {isExpanded || !isTruncated ? (
          <>
            {text}
            {isTruncated && (
              <button
                onClick={toggleExpanded}
                style={inlineBtnStyle}
              >
                Read less
              </button>
            )}
          </>
        ) : (
          <>
            {text.slice(0, maxChars)}...
            <button
              onClick={toggleExpanded}
              style={inlineBtnStyle}
            >
              Read more
            </button>
          </>
        )}
      </span>

      {link && (
        <TextHoverLinkDiv style={{ maxWidth: channel === 'facebook' ? '350px' : undefined }}>
          <TextHoverLink onClick={newWindowFunc}  style={{maxWidth:'90%'}}>
            {link}
          </TextHoverLink>
        </TextHoverLinkDiv>
      )}
    </div>
  );
};

const inlineBtnStyle = {
  background: 'none',
  border: 'none',
  color: '#007bff',
  cursor: 'pointer',
  padding: 0,
  fontSize: 'inherit',
  marginLeft: '4px',
  fontFamily:'inherit'
};

export default CollapsibleText;
